import { TASK_VISIBILITY } from 'shared/common/enums'

export const isVisibilityHidden = (arg: any) => arg === TASK_VISIBILITY.hidden

export const isVisibilityVisible = (arg: any) => arg === TASK_VISIBILITY.visible
